import { formatVariation } from "@/utils/percentage";

// Variaciones de la tabla del tab Dashboard (docs/decisiones/37-dashboard-reporte-financiero.md).
//
// El backend manda cada delta como fracción. El tono de color sigue el
// SIGNO, como en el resto del reporte: positivo en verde, negativo en rojo
// (Phil, 2026-10-08). Hasta entonces se cruzaba con la `polarity` de la fila
// (en costos y gastos un alza iba en rojo); el backend la sigue mandando y
// nadie la lee.
//
// Las filas de monto llevan variación relativa (`formatVariation`, entero
// half-up); las filas % llevan la diferencia entre los dos porcentajes escrita
// con «%», como en el mockup (88 % → 86 % = «-2%»). Steve lo confirmó con
// datos reales el 2026-10-06 (D4 de §37): no es variación relativa ni «pp».

export const TONE_POSITIVE = "positive";
export const TONE_NEGATIVE = "negative";
export const TONE_NEUTRAL = "neutral";

export const EMPTY_VALUE = "—";

export function deltaTone(delta) {
    if (delta == null || delta === 0) return TONE_NEUTRAL;
    return delta > 0 ? TONE_POSITIVE : TONE_NEGATIVE;
}

export function formatDelta(delta, { isMoney = true } = {}) {
    if (delta == null) return EMPTY_VALUE;
    if (isMoney) return formatVariation(delta, { withSign: true, dash: EMPTY_VALUE });
    const points = Math.round(delta * 100);
    if (points === 0) return "0%";
    return `${points > 0 ? "+" : "-"}${Math.abs(points)}%`;
}
